import { CommandBar, FocusZone, FontIcon, IDetailsListStyles } from "@fluentui/react";
import { ITheme } from "cayo.ui";
import styled from "styled-components";
import { Column, Row } from "@cayo/shared/components/CommonLayout";

export const getDetailsListSyles = (showBorder?: boolean): Partial<IDetailsListStyles> => {
  return {
    root: {
      paddingTop: "0 !important",
      border: showBorder ? "1px dashed #A8A8A8" : undefined,
      marginBottom: showBorder ? 12 : undefined,
      overflowY: showBorder ? "hidden" : undefined,
      selectors: {
        ".ms-DetailsHeader-cell": {
          selectors: {
            ":hover": {
              border: "1px solid rgba(0, 0, 0, 0.2)",
            },
          },
        },
        ".ms-DetailsHeader-cellSizer": {
          selectors: {
            ":after": { width: 3 },
          },
        },
        ".ms-DetailsHeader-filterChevron": {
          display: "none",
        },
        ".ms-DetailsRow-fields": {
          display: "block",
          selectors: {
            ".ms-DetailsRow-cell": {
              paddingTop: "12px !important",
              paddingLeft: 8,
              paddingRight: 8,
              height: "100%",
            },
          },
        },
      },
    },

    contentWrapper: {
      selectors: {
        ".ms-DetailsRow": {
          width: "100%",
        },
        ".ms-DetailsRow .cs-ShowOnHover": {
          visibility: "hidden",
        },
        ".ms-DetailsRow:hover .cs-ShowOnHover": {
          visibility: "visible",
        },
      },
    },

    headerWrapper: {
      fontSize: "8px",
      selectors: {
        ".ms-DetailsHeader": {
          paddingTop: 0,
          width: "100%",
        },
        ".ms-DetailsHeader-cellName": {
          fontSize: 12,
        },
      },
    },
  };
};

export const PersonaContent = styled.div`
  padding-left: 8px;
`;

export const PickerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ScrollablePaneWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto hidden;
`;

export const Absolute3px = styled.div`
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 3px;
  right: 3px;
`;

export const FontIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const NoLabel = styled.div`
  flex: 1 0 auto;
`;

export const StyledColumn = styled(Column)`
  align-items: flex-start;
  flex-grow: 1;
`;

export const StyledFocusZone = styled(FocusZone)`
  display: flex;
  align-items: center;
  padding-left: 4px;
  height: 30px;
`;

export const FavoritesCommandBar = styled(CommandBar)`
  padding: 4px;
  margin: 0 10px 0;
`;

export const ButtonsCommandBar = styled(CommandBar)`
  flex-grow: 1;
  width: 50%;
`;

export const TitleWrapper = styled(Row)`
  padding: 20px 40px 10px 20px;
  position: relative;
  overflow: hidden;
  width: calc(100% - 70px);
`;

export const FavoriteStarIcon = styled(FontIcon)<{ isFavorite: boolean }>`
  margin-top: 3px;
  color: ${(props) =>
    props.isFavorite ? (props.theme as ITheme).cayoTheme.brandColors.warning : "inherit"};
`;
